<template>
   <b-modal id="modal-1" title="Recuperar contraseña" ok-title="Reestablecer">
    <p class="my-4">Ingresa tu correo electronico para reestablecer contraseña</p>
      <b-form-input type="email" placeholder="Ingresa tu correo"></b-form-input>
  </b-modal>
</template>

<script>
export default {

}
</script>

<style scoped>

</style>

